export default __webpack_public_path__ + "static/media/Collaborator - Profile-Blue.ca952873.svg";